import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { FormPackType } from '@upstart/harmony/lib/constants';
import SidebarContainer from '../SidebarContainer';
import formPacksActions from '../../redux/formPacks/actions';
import formsActions from '../../redux/forms/actions';
import ContentPage from '../ContentPage';
import ErrorMessage from '../../components/ErrorMessage';

import { FormPackEditor, NewFormPack } from '../../components/FormPackEditor';
import DealerNav from '../../components/DealerNav';

class FormPack extends Component {
  componentDidMount() {
    const { formPackId, dealerId } = this.props.match.params;
    if (formPackId) {
      this.props.actions.formPackRequest(formPackId);
    } else {
      this.props.actions.resetFormPack(dealerId);
    }
    this.props.actions.formsRequest(dealerId);
  }

  onCreate = params => {
    this.props.actions.createFormPackRequest(params);
  };

  onUpdate = formPack => {
    this.props.actions.updateFormPackRequest(formPack);
  };

  render() {
    const { formPacks, forms, dealer, match } = this.props;
    const { dealerId } = match.params;
    const { formPack, error, fetching } = formPacks;

    // Prefill new form pack
    const newFormPack = {
      type: FormPackType.INSTORE,
      dealer_id: dealerId,
    };

    return (
      <SidebarContainer title={dealer.name} logo={dealer.logo}>
        <div className="form-packs-table">
          <DealerNav />
          {error && <ErrorMessage error={error} />}
          {formPack.id && (
            <FormPackEditor
              formPack={formPack}
              forms={forms}
              fetching={fetching}
              onUpdate={this.onUpdate}
              type={FormPackType.INSTORE}
            />
          )}
          {!formPack.id && (
            <NewFormPack
              formPack={newFormPack}
              forms={forms}
              fetching={fetching}
              onCreate={this.onCreate}
              type={FormPackType.INSTORE}
            />
          )}
        </div>
      </SidebarContainer>
    );
  }
}

FormPack.propTypes = {
  match: PropTypes.object,
  actions: PropTypes.object,
  formPacks: PropTypes.object,
  forms: PropTypes.array,
  dealer: PropTypes.object,
};

const mapStateToProps = ({ formPacks, forms, dealers }) => ({
  formPacks,
  forms: forms.forms,
  dealer: dealers.dealer,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      ...formPacksActions,
      ...formsActions,
    },
    dispatch,
  ),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ContentPage(FormPack));
